export default "__VITE_ASSET__ucRXKohw__"